import { GlobalIcon } from "get-life-storybook-ts";

interface TrustGridProps {
  translate: (key: string) => string;
  variant?: "sidebar" | "mobile";
}

const Star = ({ size = 12, color = "#00B67A" }: { size?: number; color?: string }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color} aria-hidden>
    <path d="M12 2l2.9 6.9L22 10l-5.5 4.8L18 22l-6-3.6L6 22l1.5-7.2L2 10l7.1-1.1z" />
  </svg>
);

const TrustGrid = ({ translate, variant = "sidebar" }: TrustGridProps) => {
  const items = [
    { icon: <GlobalIcon iconName="ShieldIcon" size="XS" color="#018565" />, key: "axa" },
    { icon: <GlobalIcon iconName="LockIcon" size="XS" color="#018565" />, key: "ssl" },
    { icon: <Star size={12} color="#00B67A" />, key: "trustpilot" },
    { icon: <GlobalIcon iconName="ClockIcon" size="XS" color="#018565" />, key: "noLockIn" },
  ];

  return (
    <div className={`paymentV3TrustGrid paymentV3TrustGrid--${variant}`}>
      {items.map((item) => (
        <div className="paymentV3TrustGrid__item" key={item.key}>
          {item.icon}
          <span>{translate(`paymentV3.summary.trust.${item.key}`)}</span>
        </div>
      ))}
    </div>
  );
};

export default TrustGrid;
